module.exports = __webpack_public_path__ + "static/media/m12cr0.1cfe525a.png";